import { createContext, useCallback, useContext, useRef, useState } from "react";
import { Modal } from "@/components/ui-mm/Modal";
import { t } from "@/lib/i18n";

const Ctx = createContext(null);
export const useConfirm = () => useContext(Ctx);

export function ConfirmProvider({ children }) {
  const [st, setSt] = useState(null);
  const res = useRef(null);
  const ask = useCallback((msg, opts = {}) => new Promise((r) => { res.current = r; setSt({ msg, ...opts }); }), []);
  const done = (v) => { res.current?.(v); setSt(null); };
  return (
    <Ctx.Provider value={ask}>
      {children}
      <Modal open={!!st} onClose={() => done(false)} title={st?.title || t("Please confirm")} testId="confirm-dialog">
        <p className="whitespace-pre-line text-[15px] leading-relaxed">{st?.msg}</p>
        <div className="mt-6 flex justify-end gap-2">
          <button className="mm-btn ghost" data-testid="confirm-cancel-button" onClick={() => done(false)}>{st?.no || t("Cancel")}</button>
          <button className={`mm-btn ${st?.danger ? "danger" : ""}`} data-testid="confirm-ok-button" onClick={() => done(true)}>{st?.yes || t("OK")}</button>
        </div>
      </Modal>
    </Ctx.Provider>
  );
}
